import { useMemo, useState } from 'react';
import { StepIndicatorProvider } from './StepIndicatorProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_TOTAL_STEPS = 2;
const DEFAULT_FIRST_STEP = 1;
export const LocalStepIndicatorProvider = ({
  children,
  initialStep = DEFAULT_FIRST_STEP,
  totalSteps = DEFAULT_TOTAL_STEPS
}) => {
  const [currentStep, setCurrentStep] = useState(initialStep);
  const navigationAdapter = useMemo(() => ({
    currentStep,
    navigate: setCurrentStep,
    replace: setCurrentStep
  }), [currentStep]);
  return /*#__PURE__*/_jsx(StepIndicatorProvider, {
    navigationAdapter: navigationAdapter,
    totalSteps: totalSteps,
    children: children
  });
};
//# sourceMappingURL=LocalStepIndicatorProvider.js.map